<template>
  <div class="row border">
    <div class="col-md-12">
      <h1 class="title-pages">INFORMAÇÕES</h1>
    </div>
    <div class="col-md-12">informations</div>
  </div>
</template>

<script>
export default {
  name: "Information",
};
</script>
